<template>
  <div>
    <div class="row">
      <div class="col-md-6 pb-3">
        <b-input-group size="md">
          <b-input-group-text slot="append" class="bg-white">
            <strong>
              <i class="icon ion-md-search" />
            </strong>
          </b-input-group-text>
          <b-form-input
            class="border-right-0"
            :value="filter.searchValue"
            placeholder="Search for patient , ID"
            @keyup.enter.native="onSearchText"
            @blur.native="onSearchText"
          />
        </b-input-group>
      </div>
      <div class="btn btn-link text-left " @click="resetFilters">
            <strong>
            <i class="ion-md-refresh mr-1" />
            </strong>Reset
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <v-table
          :options="tableProps"
          :total-count="totalCount"
          :loading="loading"
          :data="patientList"
        >
          <template slot="patientName" slot-scope="slotProps">
            <div class="align-items-center d-flex patient-name-content">
              <img
                :src="require('@/assets/image/boy.svg')"
                width="35"
                height="35"
                :alt="slotProps.data.datum.first_name"
                v-b-tooltip.hover
                :title="slotProps.data.datum.first_name"
              />
              <div
                class="d-flex flex-column justify-content-center align-items-center"
                v-if="slotProps"
                v-b-tooltip.hover
                :title="slotProps.data.datum.first_name"
              >
                <span
                  @click="viewPatientEHR(slotProps.data.datum.id)"
                  class="text-center btn btn-link"
                >
                  {{ slotProps.data.datum.first_name | capitalizefirst }}
                  {{ slotProps.data.datum.last_name | capitalizefirst }}
                </span>
                 <span class="btn btn-link" @click="redirectToMessage(slotProps.data.datum.mr_id)">
                  Send Message
                </span>
              </div>
            </div>
          </template>
          <template slot="todaysProgress" slot-scope="slotProps">
            <div
              class="d-flex flex-column justify-content-between align-items-center"
              v-if="slotProps"
            >
              <span class="width">
                <b-progress
                  :variant="getBarVariant(
                                  slotProps.data.datum.today_progress,
                                  slotProps.data.datum.today_total_interventions
                                )"
                  :value="parseInt(slotProps.data.datum.today_progress, 10)"
                  :max="parseInt(slotProps.data.datum.today_total_interventions)"
                />
              </span>
              <div class="d-flex justify-content-center align-items-center">
                <span
                  class="btn btn-link pl-0"
                  @click="viewPatientProgress(slotProps.data.datum)"
                >View overall</span>
                <span>
                  {{ slotProps.data.datum.today_progress
                  }}/{{ slotProps.data.datum.today_total_interventions }}
                </span>
              </div>
            </div>
          </template>
          <template slot="weeksProgress" slot-scope="slotProps">
            <div class="circle d-flex flex-row justify-content-between" v-if="slotProps">
              <div v-for="(weekProgress, index) in slotProps.data.datum.progress" :key="index">
                <div class="circle-percent-text-body">
                  <span class="percent-text" :style="{ 'font-size': '12px' }" />
                  <div class="circleContainer">
                    <v-circle
                      ref="myprogress"
                      :progress="getPercentage(weekProgress)"
                      :size="30"
                      line-cap="round"
                      :fill="fill"
                      insert-mode="append"
                      :thickness="5"
                    >
                      <p class="title">{{ weekDays[index] }}</p>
                      <span v-if="getComplete(weekProgress)" class="fa fa-check" />
                    </v-circle>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template slot="contact" v-if="slotProps" slot-scope="slotProps">
            <div class="d-flex flex-column justify-content-center">
              {{
              slotProps.data.datum.mobile_no |
              mobileformat(slotProps.data.datum.country_code)
              }}
              <span>{{ slotProps.data.datum.email }}</span>
            </div>
          </template>
          <v-patient-progress ref="patientProgress" @onViewProgressCancel="onViewProgressCancel" />
        </v-table>
      </div>
    </div>
    <v-patient-progress ref="patientProgress" @onViewProgressCancel="onViewProgressCancel" />
    <v-loader :isLoading="isLoading" />
  </div>
</template>
<script>
import colors from "@/constants/_colors";
import { mapGetters } from "vuex";
import VPatientProgress from "@/components/patient/PatientProgress.vue";
import VLoader from "@/components/loader/index.vue";
import VTable from "@/components/table/index.vue";

import VCircle from "@/components/circularProgressBar/ProgressBar.vue";

const bars = {
  success: "success",
  info: "info",
  warning: "warning",
  danger: "danger",
  primary: "primary",
  secondary: "secondary",
  dark: "dark"
};
export default {
  components: {
    VPatientProgress,
    VTable,

    VCircle,
    VLoader
  },
  data() {
    return {
      bars,
      fill: { gradient: [colors.cyan] },
      interval: null,
      progressFill: { gradient: [colors.cyan] },
      patient: {},
      weekDays: ["M", "T", "W", "T", "F", "S", "S"],
      monthDays: [],
      filter: {
        searchValue: "",
        limit: 12,
        pageNo: 1
      },
       roles: {
        CARE_NAVIGATOR: 'Navigator'
      },
      tabProps: {
        tabs: [
          {
            title: "Prescription",
            slot: "intervention"
          },
          {
            title: "Side Effects/Symptoms",
            slot: "assessment"
          },
          {
            title: "Reminders",
            slot: "reminders"
          }
        ],
        activeTabName: null
      },
      assessmentTableProps: {
        containerClass: "hide-scroll",
        columns: [
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {
              class: "text-center"
            },
            dataKey: "assessment_name",
            dataType: String,
            label: "Side Effects/Symptoms Name"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            dataKey: "target_or_time",
            dataType: String,
            label: "Side Effects/Symptoms target/time"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            cellSlot: {
              name: "current"
            },
            dataKey: "value",
            dataType: String,
            label: "Current"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            cellSlot: {
              name: "threshold"
            },
            dataKey: "threshold",
            dataType: String,
            label: "Threshold"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            cellSlot: {
              name: "status"
            },
            dataKey: "status",
            dataType: String,
            label: "Status"
          }
        ],
        enableSelect: false,
        onPageChange: this.onPageChange,
        page: 1,
        rowProps: {},
        rowsPerPage: 12,
        title: "Patients Progress"
      },
      tableProps: {
        columns: [
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {
              class: "text-left"
            },
            cellSlot: {
              name: "patientName"
            },
            dataKey: "first_name",
            dataType: String,
            label: "Name"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            dataKey: "mr_id",
            dataType: String,
            label: "ID"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            cellSlot: {
              name: "todaysProgress"
            },
            dataKey: "email",
            dataType: String,
            label: "Today's Progress"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            cellSlot: {
              name: "weeksProgress"
            },
            dataKey: "email",
            dataType: String,
            label: "This Week"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            cellSlot: {
              name: "contact"
            },
            dataKey: "phoneNumber",
            dataType: String,
            label: "Contact"
          }
        ],
        enableSelect: false,
        onPageChange: this.onPageChange,
        page: 1,
        rowProps: {},
        rowsPerPage: 10,
        title: "Patients Progress"
      }
    };
  },
  mounted() {
    this.fetchPatients();
  },
  watch: {
    filter: {
      handler: "fetchPatients",
      immediate: true
    }
  },
  methods: {
    fetchPatients() {
      this.$store.dispatch("progress/getPatientProgresses", this.filter);
    },
    onPageChange(pageNo, rowsPerPage) {
      this.tableProps.page = pageNo;
      this.filter = {
        ...this.filter,
        pageNo,
        limit: rowsPerPage
      };
    },
    onSearchText(event) {
      if (event.target.value) {
        this.filter = {
          ...this.filter,
          pageNo:'1',
          searchValue: event.target.value.toLowerCase()
        };
      }
    },
    getBarVariant(value, max) {
      if (value >= max / 1.5) return bars.success;
      if (value >= max / 2) return bars.warning;
      if (value >= max / 3) return bars.danger;
      return bars.danger;
    },
    onViewProgressCancel() {
      this.patient = {};
    },
    getPercentage(data) {
      if (data.total_intervention > 0) {
        return (data.intervention_progress / data.total_intervention) * 100;
      }
      return 0;
    },
    getDaysInterventionPercentage(dailyIntervention) {
      // eslint-disable-next-line camelcase
      const { intervention_progress, total_intervention } = dailyIntervention;
      return (
        (parseInt(intervention_progress, 10) /
          parseInt(total_intervention, 10)) *
        100
      );
    },
    getCycleInterventionPercentage(cycleIntervention) {
      // eslint-disable-next-line camelcase
      const { intervention_progress, total_intervention } = cycleIntervention;
      return (
        (parseInt(intervention_progress, 10) /
          parseInt(total_intervention, 10)) *
        100
      );
    },
    getComplete(data) {
      const value = this.getPercentage(data);
      if (value === 100) {
        return true;
      }
      return false;
    },

    getActiveClass(data) {
      const { value, threshold } = data;
      const isValueAboveThreshold =
        parseInt(value, 10) > parseInt(threshold, 10);
      return isValueAboveThreshold ? "text-danger" : "text-success";
    },
     viewPatientEHR(id) {
      this.$router.push({
        name: 'patientList.view',
        params: { id }
      });
    },
    viewPatientProgress(patient) {
      this.$refs.patientProgress.viewPatientProgress(patient);
      this.patient = patient;
    },
    resetFilters() {
        this.filter = {
          day: "all",
          limit: 12,
          pageNo: 1,
          patient: "",
          careplan: "",
          searchValue: ""
        };
         this.interventionSearch= ''
    },
    redirectToMessage(mrId) {
      const data = { mrId, isSelectedPatient: true };
      this.$store.dispatch('patient/setPatientDataToMsg', data);
      this.$router.push({ name: 'message.index' });
    },
  },
  computed: {
    ...mapGetters({
      patientList: "progress/getPatientProgresses",
      progressDetail: "progress/getPatientProgressDetails",
      loading: "progress/getLoading",
      totalCount: "progress/getTotalCount",
      isLoading: "progress/getIsPatientProgressListloading",
      permissions: "auth/getModulePermissions",
    })
  },
    created() {
        let i;
        const monthDays = [];
        const monthDaysCount = 31;
        for (i = 0; i < monthDaysCount; i += 1) {
        monthDays.push(`D${i}`);
        }
        this.monthDays = monthDays;
    },
    destroyed() {
        clearInterval(this.interval);
    },
};
</script>
<style lang="scss" scoped>
    @import './interventions.scss';
</style>